import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { isMobile } from "react-device-detect";
import UnityComponentMap from "../../unityComponentMap/UnityComponentMap";
import { resetCheckout } from "../../../../utils/redux/slices/checkoutSlice";

const StepMap = (props) => {
  const { setNextButton } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    setNextButton(true);
    dispatch(resetCheckout());
  }, []);

  return (
    <>
      <h2 className="text-white pt-6 sm:p-6 text-lg sm:text-2xl">
        Please select your lands.
      </h2>
      {isMobile ? (
        <p className="font-general text-sm">Double tap to select your lands</p>
      ) : (
        <p className="font-general text-sm">
          Click to select your lands and press NEXT to continue
        </p>
      )}
      <div>
        <UnityComponentMap
          setSelectLand={props.setSelectLand}
          closeUnity={props.closeUnity}
        />
      </div>
    </>
  );
};

export default StepMap;
